import { eEndorsements } from '../../../ui-toolkit/enums/eEndorsements';
import { endorsementOptions } from '../../../ui-toolkit/cdItems/data/endorsementOptions';
import { eUSAState } from '../../../ui-toolkit/enums/states';

export default function generateEndorsementsOptions(state?: eUSAState) {
  const texasEndorsements = [
    eEndorsements._T_17,
    eEndorsements._T_19,
    eEndorsements._T_28,
    eEndorsements._T_30,
    eEndorsements._T_31,
    eEndorsements._T_33,
    eEndorsements._T_36,
    eEndorsements._T_42,
    eEndorsements._T_42_1,
    eEndorsements._R_24,
  ];
  const defaultEndorsements = endorsementOptions.filter((e) => !texasEndorsements.includes(e.value));
  return state && state === eUSAState.TX ? endorsementOptions : defaultEndorsements;
}
